import {asCreator, withCallbacks} from '../../../../lib/utils';
import {compose} from '../../../../utils/functions';
import {actionTypes} from '../../reducers/notificationsReducer';

export const newAddressNotification = compose(
    withCallbacks,
    asCreator((data: any, id: number) => ({
        type: actionTypes.UPDATE_ADDRESS_NOTIFICATION,
        payload: data,
        id
    }))
);